module.exports = __webpack_public_path__ + "media/mypage/images/arrow_right-10f7c16d34bf3106dd2d9d498b6b68e4.png";